import { useIsAccessTokenExpired } from 'app/domains/auth/hooks/useIsAccessTokenExpired';
import { useGetCurrentUser } from 'shared/domains/documents';
import { ASSISTANT_COMPONENT_NAME } from 'shared/domains/pleditor@next';
import { PleditorError } from '../../components/PleditorError';
import { PleditorLoader } from '../../components/PleditorLoader';
import { RTCPleditor } from '../RTCPleditor';
import { useImportDocumentToCcs } from '../hooks';
import { APP_COMPOSED_PLUGINS } from '../plugins';
export function AppComposedRTCPleditor() {
    const currentUser = useGetCurrentUser();
    const { isAccessTokenExpired } = useIsAccessTokenExpired();
    const { loading, error } = useImportDocumentToCcs();
    if (loading) {
        return <PleditorLoader />;
    }
    if (error) {
        return <PleditorError />;
    }
    const toolbarItems = ['<->', 'blockComment', '|', 'commentsArchive', '|', 'toggleComments'];
    const balloonToolbarItems = ['blockComment', ASSISTANT_COMPONENT_NAME];
    return (<RTCPleditor editorName="AppComposedRTCPleditor" documentType="composed" toolbarItems={toolbarItems} balloonToolbarItems={balloonToolbarItems} currentUser={currentUser} clientPlugins={APP_COMPOSED_PLUGINS} isSessionExpired={isAccessTokenExpired}/>);
}
